import { IScenarioWellShutIn } from '../../interfaces/iscenario-well-shut-in';
import { FracGroup } from '../frac-group';
import { ScenarioWell } from '../scenario-well';

export class ScenarioWellShutInBase {
  ScenarioWellShutInId: number;
  ScenarioWellId: number | null;
  ShutInStartDate: Date | null;
  ShutInEndDate: Date | null;
  FracGroupId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FracGroup?: FracGroup;
  ScenarioWell?: ScenarioWell;

  constructor(item?: IScenarioWellShutIn) {
    if (item) {

      this.ScenarioWellShutInId = item.ScenarioWellShutInId;
      this.ScenarioWellId = item.ScenarioWellId;
      this.ShutInStartDate = item.ShutInStartDate ? new Date(item.ShutInStartDate) : null;
      this.ShutInEndDate = item.ShutInEndDate ? new Date(item.ShutInEndDate) : null;
      this.FracGroupId = item.FracGroupId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FracGroup = new FracGroup(item.FracGroup);
      this.ScenarioWell = new ScenarioWell(item.ScenarioWell);
    }
  }
}